import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant, {
  Lazyload,
  Grid,
  GridItem
} from 'vant'
import './permission' // ������
import '@/styles/index.scss' // global css
import 'vant/lib/index.css'
import './assets/flexible'
import '@/styles/sypublic.scss'
import i18n from './lang' // ���ʻ�
// import 'vue-googlemaps/dist/vue-googlemaps.css'
// import VueGoogleMaps from 'vue-googlemaps'

// Vue.use(VueGoogleMaps, {
//   load: {
//     // Google API key
//     apiKey: 'AIzaSyBniKj4eAshfmNsuF9x1MgsUu4GO8ipPFY',
//     // Enable more Google Maps libraries here
//     libraries: ['places'],
//     // Use new renderer
//     useBetaRenderer: false
//   }
// })
const defaultAvatar = require('@/assets/avatar.png')

// import VConsole from 'vconsole'
// new VConsole()
// __DEV__ ���� DefinePlugin ע���ȫ�ֳ���
// ����ʱ���� vConsole
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'development-bendi') {
  // �²�һ������֧�� import ��ʽ
  const VConsole = require('vconsole')
  new VConsole()
}

Vue.use(Grid).use(GridItem)
Vue.use(Vant)
Vue.use(Lazyload, {
  loading: defaultAvatar,
  error: defaultAvatar
})

Vue.config.productionTip = false
// Vue.prototype.$wx = wxjsdk
Vue.mixin({
  created() {
    console.log(this, 'this.$route.meta')
    if (this.$route) {
      document.title = this.$t('routerBase.' + this.$route.meta.i18n)
    }
  },
  methods: {
    $c(base, x, y = '') {
      return this.$t(base).replace('**', x).replace('***', y)
    }
  }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

